

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <LoginFrame></LoginFrame>

</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import LoginFrame from '../components/usuario/LoginFrame.vue';





export default {
    data () {
    return {
              
    }
  },
  components: {
    
    LoginFrame
    
  },

  methods: {

}

}
    

</script>


